import { createSvgIcon } from '@mui/material/utils';

const MetricBattery = createSvgIcon(
  <svg width="32" height="16" viewBox="0 0 32 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27.2002 16L1.6002 16C0.720199 16 0.000199604 15.28 0.000199642 14.4L0.000200202 1.6C0.00020024 0.719999 0.7202 -1.33232e-06 1.6002 -1.29386e-06L27.2002 -1.74846e-07C28.0802 -1.3638e-07 28.8002 0.72 28.8002 1.6L28.8002 4.8L31.2002 4.8L31.2002 11.2L28.8002 11.2L28.8002 14.4C28.8002 15.28 28.0802 16 27.2002 16ZM27.2002 14.4L27.2002 1.6L1.6002 1.6L1.6002 14.4L27.2002 14.4Z" fill="white"/>
<rect x="2.99707" y="3" width="16" height="10" fill="white"/>
</svg>,
  'MetricBattery',
);

export default MetricBattery;
